import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { PageHeader, Tag, Button } from 'antd';
import { pageHeaderStyle, pageTitle } from '../util/Style';
import { AgGridReact } from 'ag-grid-react';
import Select from 'react-select';
import DatePicker from "react-datepicker";  

const height = window.innerHeight * .80;

const defaultColDef = {
    sortable: true,
    resizable: true,
    filter: true,
    flex: 1,
    width: 100,
};

const columnDefs = [
    {
        headerName: "",field: "select",width: 30,checkboxSelection: true,headerCheckboxSelection: true,headerCheckboxSelectionFilteredOnly: true,pinned: "middle" },
    {
        headerName: 'Status',
        field: 'PrintStatus',
        width: 10,
        type: 'numberColumn',
        cellStyle: params => {
            if (params.value === 1) {
                return {color: 'white', backgroundColor: 'rgb(27,160,97)'};
            }
            return {color: 'white', backgroundColor: 'rgb(204,47,16)'};
        }
    },
    { headerName: 'Bucket', field: 'bucket', type: 'numericColumn' },
    { headerName: 'Branch', field: 'BranchId', type: 'numericColumn' },
    { headerName: 'Doctor Id', field: 'ReferrerId', type: 'numericColumn' },
    { headerName: 'Doctor Name', field: 'Doctorname' },
    { headerName: 'Total Bill Amount', field: 'Total', type: 'numericColumn', filter: 'agNumberColumnFilter', headerClass: 'ag-right-aligned-header', cellClass: 'ag-right-aligned-cell' },
    { headerName: 'Total Paid', field: 'Payable', type: 'numericColumn', filter: 'agNumberColumnFilter', headerClass: 'ag-right-aligned-header', cellClass: 'ag-right-aligned-cell' },
];

class PaymentSummaryUI extends Component {

    gridRef = React.createRef();

    constructor(props) {
        super(props);
        this.store = props.store;
        this.state = {  
            startDate: new Date(),
            endDate: null,
            selectedRows: [],
            isMerging: false
        };  
    }

     /** Back button */
    goBack = () => {
        const { collectionType } = this.props.params;
        this.props.appStore.currentComponent = { label: "Payments", key: "payments" };
    }

    handleChange = (dates) => {  
        const [start, end] = dates;
        this.setState({  
          startDate: start,
          endDate: end  
        })  

        console.log(start);

        let startDate = this.changeDateFormat(start);
        let endDate = this.changeDateFormat(end);

        this.store.filterBucket(startDate,endDate);
    }  

    
    changeDateFormat(date) {

        const yyyy = date.getFullYear();
        let mm = date.getMonth() + 1; // Months start at 0!
        let dd = date.getDate();

        if (dd < 10) dd = '0' + dd;
        if (mm < 10) mm = '0' + mm;

        const formattedDate = yyyy + '' + mm + '' + dd;

        return formattedDate;

    }

    fetchPayments = () => {
        this.store.fetchPayments();
        this.store.GetallBranchName();
    }

    countTag = () => {
        if (this.store.isDone) {
            return (
                <>
                    <Tag color="#108ee9">{this.store.rowCount} Rows </Tag>
                    <Tag color="geekblue"> {this.store.totalPaidSum} Total Paid </Tag>
                </>
            )
        }

        if (this.store.isError) {
            return <Tag color="red">...</Tag>
        }
    }

    onBtnClick = async () => {

        const url = await this.store.showSummary();

        window.open(url);
    }

    monthlyFilter = () => {
        if(this.store.collectionType == "monthly") {
            return(
                <div style={{ display: 'inline-block', width: '25%', float: 'right' }}>
                    <Select options={this.store.bucketList} onChange={(value) => this.store.filterBucket(value.label,value.label)} placeholder='Bucket' />
                </div>)
        }
        else {
            return (
                <div style={{ display: 'inline-block', width: '15%', float: 'right', marginTop: '5px' }}>
                    <DatePicker  selected={this.state.startDate} onChange={this.handleChange} startDate={this.state.startDate} endDate={this.state.endDate} selectsRange dateFormat="dd/MM/yyyy" />

                </div>
              );
        }
        
    }

    // onSelectionChanged = () => {
    //     debugger;
    //     const selectedRows = this.gridRef.current.api.getSelectedRows();

    //     const referrerId = selectedRows[0].ReferrerId;
    //     const doctorName = selectedRows[0].Doctorname;
    //     const collectionType = this.store.collectionType;
    //     const title= this.props.title;

    //     const params = { parentKey: "payments", referrerId, doctorName, collectionType,title };

    //     this.props.appStore.currentComponent = { label: "Doctor Payment Details", key: "doctorPaymentDetails", params: params };
    // }

    onSelectionChanged = () => {
        const selectedNodes = this.gridRef.current.api.getSelectedNodes();
        // // const selectedRows = selectedNodes.map(node => node.data).filter(row => row.PrintStatus === 0);
        // const selectedNodes = this.gridRef.current.api.getSelectedNodes();
        // // const selectedRows = selectedNodes.map(node => node.data).filter(row => row.PrintStatus === 0);
        // const selectedRows =[];
        // // if (selectedNodes.map(node => node.data).filter(row => row.PrintStatus === 0) === 0)
        // // {
        // //      selectedRows = selectedNodes.map(node => node.data).filter(row => row.PrintStatus === 1);
        // // }
        // // else
        // // {
        //      selectedRows = selectedNodes.map(node => node.data).filter(row => row.PrintStatus === 0);
        // // }
        const selectedRows = selectedNodes.map(node => node.data).filter(row => row.PrintStatus === 0);
        console.log("selected row : " + selectedRows)
        this.setState({ selectedRows });
    }

        onRowDoubleClicked = (event) => {
        const row = event.data;
        if (!row) return;

        const { ReferrerId, Doctorname } = row;

        this.props.appStore.currentComponent = {
            label: "Doctor Payment Details",
            key: "doctorPaymentDetails",
            params: {
                parentKey: "payments",
                referrerId: ReferrerId,
                doctorName: Doctorname,
                collectionType: this.store.collectionType,
                title: this.props.title
            }
        };
    };

    downloadSelectedPDFs = async () => {

        const { selectedRows } = this.state;
        console.log("Selected rows for PDF download:", selectedRows);
        if (!selectedRows.length) return alert("Please select at least one row with Status = 0.");

        this.setState({ isMerging: true }); // show loader

        try {
            const result = await this.store.mergeInvoicesPdf(selectedRows);
            // console.log("Merge result:", result);
            if (!result || !result.blob) return alert("Error generating PDF");

            const link = document.createElement('a');
            link.href = URL.createObjectURL(result.blob);
            link.download = 'Merged_Invoices_' + new Date().toISOString().slice(0, 10) + '.pdf';
            link.click();


            const status = await this.store.UpdateMultipleIcPrintStatus(result.mergedInvoices);
            if (status === 'success') {
                alert("Invoices downloaded and statuses updated successfully.");
            }
        } catch (err) {
            console.error(err);
            alert("Error generating PDF");
        }
        finally {
            this.setState({ isMerging: false }); // hide loader
        }
    }

    render() {
        const payments = this.store.filteredPayments;
        return (
            <>
                <div>
                    <div style={{ display: 'inline-block', float: 'right' , marginRight: 6, marginTop: 3}}>
                        <Button variant="outlined" onClick={() => {
                            this.downloadSelectedPDFs();
                        }} disabled={this.state.selectedRows.length === 0}>
                            Download Invoice
                        </Button>
                    </div>

                    <div style={{ display: 'inline-block', float: 'right' , marginRight: 6, marginTop: 3}}>
                        <Button variant="outlined" onClick={() => {
                            this.onBtnClick();
                        }}>
                            View Invoice
                        </Button>
                    </div>

                    <div style={{ display: 'inline-block' , justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
                        <PageHeader style={pageHeaderStyle} title={pageTitle("Payments")} tags={this.countTag()} />
                    </div>
                    <div style={{ display: 'inline-block', width: '25%', float: 'right' }}>
                        <Select options={this.store.branchList} onChange={(value) => this.store.filterBranch(value.value, value.label)} placeholder='Branch' />
                    </div>
                    {this.monthlyFilter()}
                    
                    
                    
                </div>
                {this.state.isMerging && (
                    <div className="loader-overlay">
                        <div className="loader">Generating Payment Invoice...</div>
                    </div>
                )}
                <div className="ag-theme-alpine" style={{ height: height, width: '100%' }}>
                    <AgGridReact
                        rowHeight={30}
                        ref={this.gridRef}
                        defaultColDef={defaultColDef}
                        rowData={payments}
                        rowSelection={'multiple'}
                        suppressRowClickSelection={true} 
                        onSelectionChanged={this.onSelectionChanged}
                        onRowDoubleClicked={this.onRowDoubleClicked}
                        columnDefs={columnDefs}
                        onGridReady={this.fetchPayments}>
                    </AgGridReact>
                </div>
            </>
        )
    }
}

export default observer(PaymentSummaryUI)
